/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryReturnType,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AiMessage,
  AiMessageRequestInput,
  CreateAiMessageParams,
  ListAiMessagesParams,
  PaginatedAiMessages,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create AI Message
 */
export const createAiMessage = (
    aiMessageRequestInput: MaybeRefOrGetter<AiMessageRequestInput>,
    params: MaybeRefOrGetter<CreateAiMessageParams>,
 signal?: AbortSignal
) => {
      aiMessageRequestInput = toValue(aiMessageRequestInput);
params = toValue(params);

      return axiosClient<AiMessage>(
      {url: `/ai/messages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aiMessageRequestInput,
        params, signal
    },
      );
    }




export const getCreateAiMessageMutationKey = () => ['createAiMessage'] as const;

export const getCreateAiMessageMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiMessage>>, TError,CreateAiMessageMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAiMessage>>, TError,CreateAiMessageMutationVariables, TContext> => {

const mutationKey = getCreateAiMessageMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAiMessage>>, CreateAiMessageMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  createAiMessage(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAiMessageMutationResult = NonNullable<Awaited<ReturnType<typeof createAiMessage>>>
    export type CreateAiMessageMutationBody = AiMessageRequestInput
    export type CreateAiMessageMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CreateAiMessageMutationVariables = {data: AiMessageRequestInput;params: CreateAiMessageParams}

    /**
 * @summary Create AI Message
 */
export const useCreateAiMessage = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiMessage>>, TError,CreateAiMessageMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createAiMessage>>,
        TError,
        CreateAiMessageMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAiMessageMutationOptions(options), queryClient);
    }
    /**
 * @summary List of AI Messages
 */
export const listAiMessages = (
    params: MaybeRefOrGetter<ListAiMessagesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedAiMessages>(
      {url: `/ai/messages`, method: 'GET',
        params, signal
    },
      );
    }




export const getListAiMessagesInfiniteQueryKey = (params?: MaybeRefOrGetter<ListAiMessagesParams>,) => {
    return [
    'infinite', 'ai','messages', ...(params ? [params] : [])
    ] as const;
    }

export const getListAiMessagesQueryKey = (params?: MaybeRefOrGetter<ListAiMessagesParams>,) => {
    return [
    'ai','messages', ...(params ? [params] : [])
    ] as const;
    }


export const getListAiMessagesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listAiMessages>>, ListAiMessagesParams['page']>, TError = ErrorType<void>>(params: MaybeRefOrGetter<ListAiMessagesParams>, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAiMessages>>, TError, TData, QueryKey, ListAiMessagesParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiMessagesInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiMessages>>, QueryKey, ListAiMessagesParams['page']> = ({ signal, pageParam }) => listAiMessages({...toValue(params), 'page': pageParam ?? toValue(params)?.['page']}, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAiMessages>>, TError, TData, QueryKey, ListAiMessagesParams['page']>
}

export type ListAiMessagesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listAiMessages>>>
export type ListAiMessagesInfiniteQueryError = ErrorType<void>


/**
 * @summary List of AI Messages
 */

export function useListAiMessagesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listAiMessages>>, ListAiMessagesParams['page']>, TError = ErrorType<void>>(
 params: MaybeRefOrGetter<ListAiMessagesParams>, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAiMessages>>, TError, TData, QueryKey, ListAiMessagesParams['page']>>, }
 , queryClient?: QueryClient
 ): UseInfiniteQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAiMessagesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export const getListAiMessagesQueryOptions = <TData = Awaited<ReturnType<typeof listAiMessages>>, TError = ErrorType<void>>(params: MaybeRefOrGetter<ListAiMessagesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiMessages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiMessagesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiMessages>>> = ({ signal }) => listAiMessages(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiMessages>>, TError, TData>
}

export type ListAiMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof listAiMessages>>>
export type ListAiMessagesQueryError = ErrorType<void>


/**
 * @summary List of AI Messages
 */

export function useListAiMessages<TData = Awaited<ReturnType<typeof listAiMessages>>, TError = ErrorType<void>>(
 params: MaybeRefOrGetter<ListAiMessagesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiMessages>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAiMessagesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete AI Message
 */
export const deleteAiMessage = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/ai/messages/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteAiMessageMutationKey = () => ['deleteAiMessage'] as const;

export const getDeleteAiMessageMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiMessage>>, TError,DeleteAiMessageMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiMessage>>, TError,DeleteAiMessageMutationVariables, TContext> => {

const mutationKey = getDeleteAiMessageMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiMessage>>, DeleteAiMessageMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteAiMessage(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiMessageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiMessage>>>

    export type DeleteAiMessageMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteAiMessageMutationVariables = {id: string}

    /**
 * @summary Delete AI Message
 */
export const useDeleteAiMessage = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiMessage>>, TError,DeleteAiMessageMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiMessage>>,
        TError,
        DeleteAiMessageMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAiMessageMutationOptions(options), queryClient);
    }
    /**
 * @summary AI Message Details
 */
export const getAiMessage = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<AiMessage>(
      {url: `/ai/messages/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetAiMessageQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'ai','messages',id
    ] as const;
    }


export const getGetAiMessageQueryOptions = <TData = Awaited<ReturnType<typeof getAiMessage>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiMessage>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiMessageQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiMessage>>> = ({ signal }) => getAiMessage(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiMessage>>, TError, TData>
}

export type GetAiMessageQueryResult = NonNullable<Awaited<ReturnType<typeof getAiMessage>>>
export type GetAiMessageQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary AI Message Details
 */

export function useGetAiMessage<TData = Awaited<ReturnType<typeof getAiMessage>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiMessage>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAiMessageQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






